import Reflux from "reflux";
import UserService from "../service/UserService";
import SiteService from "../service/SiteService.mjs";

var UserActions = Reflux.createActions({
  login: { asyncResult: true, children: ["complete", "fail"] },
  logout: { asyncResult: true, children: ["complete", "fail"] },
  refreshToken: { asyncResult: true },
  loadAssets: { asyncResult: true, children: ["complete", "fail"] },
  loadFolders: { asyncResult: true, children: ["complete", "fail"] },
  initializeSites: { asyncResult: true, children: ["complete", "fail"] },
  createSite: { asyncResult: true, children: ["complete", "fail"] },
  copySite: { asyncResult: true, children: ["complete", "fail"] },
  deleteSite: { asyncResult: true, children: ["complete", "fail"] },
  switchAccount: { asyncResult: true, children: ["complete", "fail"] },
  refreshUserModal: { asyncResult: true, children: ["complete", "fail"] },
  loadDomains: {},
  loadAvailableDomains: { asyncResult: true, children: ["complete", "fail"] },
  loadAccountInfo: {},
  initialize: {},
  trackEvent: {},
  trackPostHogEvent: {},
  launchTour: {},
  saveSite: {},
  openStore: {},
  userSubscribed: {},
  updateConfiguration: {},
  triggerSatismeterEvent: {},
  createSiteDesignsFolder: { asyncResult: true, children: ["complete", "fail"] },
  updateSiteDesignsFolder: { asyncResult: true, children: ["complete", "fail"] },
  deleteSiteDesignsFolder: { asyncResult: true, children: ["complete", "fail"] },
  getSiteDesignsFolders: { asyncResult: true, children: ["complete", "fail"] },
  assignSitesToFolder: { asyncResult: true, children: ["complete", "fail"] },
});

UserActions.login.listen(function (data) {
  UserService.login(data).then(this.complete).catch(this.fail);
});

UserActions.logout.listen(function (data) {
  UserService.logout(data).then(this.complete).catch(this.fail);
});

UserActions.refreshToken.listen(function (data) {
  UserService.refreshToken(data).then(UserActions.login.complete).catch(UserActions.login.fail);
});

UserActions.loadAssets.listen(function (data) {
  UserService.loadAssets(data).then(this.complete).catch(this.fail);
});

UserActions.loadFolders.listen(function (data) {
  UserService.getFolders(data).then(this.complete).catch(this.fail);
});

UserActions.initializeSites.listen(function (data) {
  UserService.loadSites(data).then(this.complete).catch(this.fail);
});

UserActions.createSite.listen(function (data) {
  UserService.createSite(data).then(this.complete).catch(this.fail);
});

UserActions.copySite.listen(function (data) {
  UserService.createSite(data).then(this.complete).catch(this.fail);
});

UserActions.deleteSite.listen(function (data) {
  SiteService.removeSite(data).then(this.complete).catch(this.fail);
});

UserActions.switchAccount.listen(function (id) {
  UserService.switchAccount(id).then(this.complete).catch(this.fail);
});

UserActions.loadAvailableDomains.listen(function (userId) {
  UserService.loadAvailableDomains(userId).then(this.complete).catch(this.fail);
});

UserActions.refreshUserModal.listen(function () {
  UserService.refreshToken().then(this.complete).catch(UserActions.login.fail);
});

/**
 * Action to create a new site designs folder.
 * Calls UserService.createSiteDesignsFolder with provided data.
 *
 * @function
 * @param {Object} data - The data for the new folder (e.g., { name: string, ... }).
 */
UserActions.createSiteDesignsFolder.listen(function (data) {
  UserService.createSiteDesignsFolder(data).then(this.complete).catch(this.fail);
});

/**
 * Action to update an existing site designs folder.
 * Calls UserService.updateSiteDesignsFolder with provided folderId and data.
 *
 * @function
 * @param {Object} data - The update data, must include:
 * @param {number|string} data.folderId - The ID of the folder to update.
 * @param {Object} data - The updated folder information (e.g., { name: string, ... }).
 */
UserActions.updateSiteDesignsFolder.listen(function (data) {
  UserService.updateSiteDesignsFolder({ folderId: data.folderId, data: data.data })
    .then(this.complete)
    .catch(this.fail);
});

/**
 * Action to delete a site designs folder.
 * Calls UserService.deleteSiteDesignsFolder with provided folderId.
 *
 * @function
 * @param {Object} data - The data object containing:
 * @param {number|string} data.folderId - The ID of the folder to delete.
 */
UserActions.deleteSiteDesignsFolder.listen(function (data) {
  UserService.deleteSiteDesignsFolder({ folderId: data.folderId })
    .then(this.complete)
    .catch(this.fail);
});

/**
 * Action to retrieve all site designs folders.
 * Calls UserService.getSiteDesignsFolders.
 *
 * @function
 */
UserActions.getSiteDesignsFolders.listen(function () {
  UserService.getSiteDesignsFolders().then(this.complete).catch(this.fail);
});

/**
 * Action to assign one or more sites to one or more folders.
 * Calls UserService.assignSitesToFolder with provided siteIds and folderIds.
 *
 * @function
 * @param {Object} data - The data object containing:
 * @param {number[]} data.siteIds - An array of site IDs to move.
 * @param {number[]} data.folderIds - An array of folder IDs to assign the sites to.
 */
UserActions.assignSitesToFolder.listen(function (data) {
  UserService.assignSitesToFolder({ siteIds: data.siteIds, folderIds: data.folderIds })
    .then(this.complete)
    .catch(this.fail);
});

export default UserActions;
